<div class="solutions md:px-20 md:py-20 sl:px-4 sl:py-8">
    <div class="flex heading justify-between flex-wrap flex-col xl:gap-x-[80px] xl:flex-row sl:items-start xl:items-center">
        <div class="title flex-1">
            <h2><span class="highlight md:text-64 sl:text-36">Solutions</span><br /><span class="sub md:text-56 sl:text-32">for your success.</span></h2>
        </div>
        <div class="description flex-1 sl:mt-4 md:text-20 sl:text-14">
            <p>Our dedicated team specializes in transforming your ideas into reality. We have tightly managed scrum team and optimized agile development cycle to ensure your goals are achieved.</p>
        </div>
    </div>

    <div class="accordion flex flex-col xl:flex-row xl:gap-x-[80px] md:mt-16 sl:mt-8">
        <div class="left flex-1">
            <ng-container *ngFor="let item of accordionItems; let i = index">
                <div class="accordion-item" [class.active]="item.active">
                    <div class="accordion-header flex justify-between items-center" (click)="toggleAccordion(i)" [class.active]="item.active">
                        {{ item.title }}
                        <span class="arrow">
                            <img src="assets/images/solutions/collapse.png" [class.hidden]="!item.active" />
                            <img src="assets/images/solutions/plus.png" [class.hidden]="item.active" />
                        </span>
                    </div>

                    <div class="accordion-content" *ngIf="item.active">
                        <ng-container *ngFor="let block of item.content">
                            <div *ngIf="block.type === 'title'" class="content-title">
                                {{ block.text }}
                            </div>
                            <p *ngIf="block.type === 'paragraph'" class="content-paragraph">
                                {{ block.text }}
                            </p>
                        </ng-container>
                    </div>
                </div>
                <img *ngIf="activeIndex === i" [src]="item.image" class="illustration md:block xl:hidden md:mt-[24px] sl:mt-[20px]" />
            </ng-container>
        </div>

        <div class="right flex-1 xl:block hidden">
            <img *ngIf="accordionItems[activeIndex].image" [src]="accordionItems[activeIndex].image" class="illustration" />
        </div>
    </div>
</div>
